export default __webpack_public_path__ + "static/media/maintainence_active.9fce562d.svg";